import { IServices, MoneyServiceEvent } from "@netent/origin";
import { IPlayUIState, MoneyType } from "@netent/playui";
import { Store } from "redux";
import { settingsState } from "../../init/settings";
import { IStoreAction, IStoreState } from "../../store";
import { ListenerCreator } from "../../types";

const balanceChanged = (services: IServices) => (): IPlayUIState => ({
  balance: {
    valueInCash: services.money.getBalanceCash(),
    valueInCoins: services.money.getBalanceCoins()
  }
});

const typeChanged = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>
) => (): IPlayUIState => {
  const type = services.money.getType();

  switch (type) {
    case "coins":
      return {
        moneyType: MoneyType.COINS,
        settings: settingsState(services, store)
      };
    default:
      return {
        moneyType: MoneyType.CASH,
        settings: settingsState(services, store)
      };
  }
};

export const listeners = new Map<MoneyServiceEvent, ListenerCreator>([
  ["balanceChanged", balanceChanged],
  ["typeChanged", typeChanged]
]);
